import React from "react";

// Components
import RoadMap from "../../../Courses/RoadMap";
import StudyPathSideBar from "../../../Courses/StudyPathSideBar";

// Utils
import ThemeProvider from "../../../utils/theme";

// Styles
import styles from "./index.module.css";

const CourseShow = ({ courseId }) => {
  return (
    <ThemeProvider>
      <div className={styles.container}>
        {/* Sidebar */}
        <StudyPathSideBar courseId={courseId} />

        <div className={styles.roadmapContainer}>
          <RoadMap courseId={courseId} />
        </div>
      </div>
    </ThemeProvider>
  )
};

export default CourseShow;
